import React from "react";

import styles from "./../formField.module.scss";

let OptionGroup = ({ items, disabled, field }) => {
	return Object.entries(items).map((item, key) => {
		return (
			<optgroup label={item[0]} key={key}>
				{item[1].map((item, key) => {
					return (
						<option
							key={key}
							className={styles.dropdownItemValid}
							disabled={disabled}
							value={item[field]}
						>
							{item.name}
						</option>
					);
				})}
			</optgroup>
		);
	});
};

export default OptionGroup;
